import { Chip } from '@/shared/component';

export default function ConfirmedChip() {
  return <Chip name='리자 인증' variant='gradient' />;
}
